import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {GroupDomService} from "../../services/groupDOMService/group-dom.service";
import {animateShow} from "../../animations/showHideAnimation";
import {debounceTime, delay, filter, skipWhile} from 'rxjs/operators';
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
import {Group} from "../../classes/Groups/Group";
import {GroupService} from "../../services/groupService/group-service.service";
import {DomEventsService} from "../../services/dom-event-services/dom-events.service";
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {timer} from "rxjs";
import {Item} from '@src/app/models/Item';

@Component({
  selector: 'app-group-additional-block-list',
  templateUrl: './group-additional-block-list.component.html',
  styleUrls: ['./group-additional-block-list.component.scss'],
  animations: [animateShow],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupAdditionalBlockListComponent extends AbstractObserver implements OnInit{

  @ViewChild('element', {static: false}) element;

  public isGroupActionsVisible = false;
  public position = {top: 0, left: 0};
  public Yiit = Yiit;
  private delaySubscribe = false;
  private currentGroup:Group = null;

  constructor(private groupDom: GroupDomService,private gs: GroupService, private cd: ChangeDetectorRef, private domEvents: DomEventsService, private bsModal: EsBsModalService) {
    super();
  }

  ngOnInit(): void {
    this.groupDom.isVisible$.pipe(filter(val => {return !this.delaySubscribe;})).subscribe((val: boolean) => {
      this.isGroupActionsVisible = val;
      if (!this.isGroupActionsVisible){
        timer(400).subscribe(()=>{
          this.currentGroup = null;
        });
      }
      this.cd.detectChanges();
      //this.domEvents.currentActiveAdditionalMenuElement = this.isGroupActionsVisible ? this.element : null;
      //this.cd.detectChanges();
    });

    this.domEvents.sidebarState$.pipe(filter(val => !val && this.isGroupActionsVisible)).subscribe(()=>{
      if (this.isGroupActionsVisible) {
        this.isGroupActionsVisible = false;
        this.cd.detectChanges();
        this.domEvents.currentActiveAdditionalMenuElement = null;
        this.currentGroup = null;
        this.cd.detectChanges();
      }
    });

    this.subscribeToObservable(this.groupDom.activeGroup$, (group)=>{
      if (this.isGroupActionsVisible){
        this.isGroupActionsVisible = false;
        this.delaySubscribe = true;
        this.cd.detectChanges();
        setTimeout(()=>{
          this.delaySubscribe = false;
          this.isGroupActionsVisible = true;
          this.setNewGroup(group);
        }, 300)
      }
      else{
        this.setNewGroup(group);
      }
    });
  }

  private setNewGroup(group){
    this.currentGroup = group;
    this.position = this.groupDom.position;

    // this.domEvents.currentActiveAdditionalMenuElement = this.element;
    this.cd.detectChanges();
  }

  removeGroup(){
    this.isGroupActionsVisible = false;
    this.domEvents.isClickDisabled = true;
    this.bsModal.openModal({modalId: '#group-remove-confirm-modal'});
  }

  removeCurrentGroup(status){
    if (status){
      return this.bsModal.closeModal(()=>{
        this.gs.removeGroup(this.currentGroup);
        this.groupDom.isVisible$  = false;
        this.domEvents.isClickDisabled = false;
        this.cd.detectChanges();
      });
    }
    this.groupDom.isVisible$  = false;
    this.cd.detectChanges();

  }

  addSubGroup() {
    this.gs.addSubgroup(this.currentGroup);
    this.groupDom.isVisible$ = false;
  }

  focusOnRename(){
    let inputElm = this.groupDom.activeGroupInputDOM;
    if (inputElm){
      inputElm.focus();
      this.groupDom.isVisible$ = false;
      this.cd.detectChanges()
    }
  }
}
